import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getFormations = () => axios.get(`${API}/formations`).then((r) => r.data);
export const getFormationsAdmin = () => axios.get(`${API}/admin/formations`, auth()).then((r) => r.data);
export const getArticles = () => axios.get(`${API}/articles`).then((r) => r.data);
export const getArticle = (slug) => axios.get(`${API}/articles/${slug}`).then((r) => r.data);
export const getRapports = () => axios.get(`${API}/rapports`).then((r) => r.data);
export const getActivites = () => axios.get(`${API}/activites`).then((r) => r.data);
export const getTemoignages = () => axios.get(`${API}/temoignages`).then((r) => r.data);
export const postContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const postPartenaire = (data) => axios.post(`${API}/partenaires`, data).then((r) => r.data);
export const uploadPartenaireLogo = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/partenaires/documents`, fd).then((r) => r.data);
};
export const getPartenairesPublic = () => axios.get(`${API}/partenaires/public`).then((r) => r.data);
export const setPartenaireStatut = (id, statut) => axios.put(`${API}/admin/partenaires/${id}/statut`, { statut }, auth()).then((r) => r.data);
export const postBenevole = (data) => axios.post(`${API}/benevoles`, data).then((r) => r.data);
export const postInfolettre = (data) => axios.post(`${API}/infolettre`, data).then((r) => r.data);
export const postDesabonnementInfolettre = (token) => axios.post(`${API}/infolettre/desabonnement`, { token }).then((r) => r.data);

// ---- Inscriptions et paiement ----
export const postInscription = (data) => axios.post(`${API}/inscriptions`, data).then((r) => r.data);
export const getPaypalConfig = () => axios.get(`${API}/paypal/config`).then((r) => r.data);
export const createPaypalOrder = (inscriptionId) => axios.post(`${API}/paypal/commande`, { inscription_id: inscriptionId }).then((r) => r.data);
export const capturePaypalOrder = (orderId) => axios.post(`${API}/paypal/commande/${orderId}/capture`).then((r) => r.data);

// ---- Admin ----
export const saveToken = (t) => localStorage.setItem("hora_admin_token", t);
export const clearToken = () => localStorage.removeItem("hora_admin_token");
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("hora_admin_token")}` } });

export const login = (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const verify2fa = (email, code) => axios.post(`${API}/auth/verify-2fa`, { email, code }).then((r) => r.data);
export const changePassword = (current_password, new_password) => axios.post(`${API}/auth/change-password`, { current_password, new_password }, auth()).then((r) => r.data);
export const getMe = () => axios.get(`${API}/auth/me`, auth()).then((r) => r.data);
export const adminCreate = (type, data) => axios.post(`${API}/admin/${type}`, data, auth()).then((r) => r.data);
export const adminUpdate = (type, id, data) => axios.put(`${API}/admin/${type}/${id}`, data, auth()).then((r) => r.data);
export const adminDelete = (type, id) => axios.delete(`${API}/admin/${type}/${id}`, auth()).then((r) => r.data);
export const getMessagesAdmin = () => axios.get(`${API}/admin/messages`, auth()).then((r) => r.data);
export const getPartenairesAdmin = () => axios.get(`${API}/admin/partenaires`, auth()).then((r) => r.data);
export const getBenevolesAdmin = () => axios.get(`${API}/admin/benevoles`, auth()).then((r) => r.data);
export const uploadBenevoleDocument = (typeDocument, file) => {
  const fd = new FormData();
  fd.append("type_document", typeDocument);
  fd.append("file", file);
  return axios.post(`${API}/benevoles/documents`, fd).then((r) => r.data);
};
export const getInscriptionsAdmin = () => axios.get(`${API}/admin/inscriptions`, auth()).then((r) => r.data);
export const getInfolettreAdmin = () => axios.get(`${API}/admin/infolettre`, auth()).then((r) => r.data);
export const uploadRapportPdf = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/rapports/${id}/pdf`, fd, auth()).then((r) => r.data);
};
export const uploadActivitePhoto = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/activites/${id}/photos`, fd, auth()).then((r) => r.data);
};
export const deleteActivitePhoto = (id, photoIndex) =>
  axios.delete(`${API}/admin/activites/${id}/photos/${photoIndex}`, auth()).then((r) => r.data);

// Bourses
export const getCampagneBourse = () => axios.get(`${API}/bourses/campagne`).then((r) => r.data);
export const uploadBourseDocument = (typeDocument, file) => {
  const fd = new FormData();
  fd.append("type_document", typeDocument);
  fd.append("file", file);
  return axios.post(`${API}/bourses/documents`, fd).then((r) => r.data);
};
export const postBourseDemande = (data) => axios.post(`${API}/bourses/demandes`, data).then((r) => r.data);
export const getCampagneBourseAdmin = () => axios.get(`${API}/admin/bourses/campagne`, auth()).then((r) => r.data);
export const updateCampagneBourse = (data) => axios.put(`${API}/admin/bourses/campagne`, data, auth()).then((r) => r.data);
export const getBourseDemandesAdmin = () => axios.get(`${API}/admin/bourses/demandes`, auth()).then((r) => r.data);
export const updateBourseStatut = (id, statut) => axios.put(`${API}/admin/bourses/demandes/${id}/statut`, { statut }, auth()).then((r) => r.data);
export const downloadBourseDocument = (documentId) =>
  axios.get(`${API}/admin/bourses/documents/${documentId}`, { ...auth(), responseType: "blob" }).then((r) => r.data);
export const deleteBourseDemande = (id) => axios.delete(`${API}/admin/bourses/demandes/${id}`, auth()).then((r) => r.data);

export const formatApiError = (detail) => {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
